
<section class="d-none d-md-block" id="products">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <h2 class="title text-center">Productos</h2>
                <div class="row" v-if="isLoading">
                    <div class="col-12 text-center">
                        <div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </div>
                </div>
                <carousel v-if="!isLoading && products.length > 0"
                          :navigationEnabled="true" :paginationEnabled="false" :perPage=4 :centerMode="true"
                          :loop="false" navigationNextLabel="&#x276F;" navigationPrevLabel="&#x276E;">
                    <slide v-for="(product, index) in OrdenedProducts" :key="index">
                        <div class="ml-3 card card-product-small" style="width: 90%" @click="goToProduct(product)">
                            <div class="card-header text-center">
                                <img class="img-product-card"
                                     :src="product['producto_imagen']['public_path']"
                                     :alt="product['producto_imagen']['alt']">
                            </div>
                            <div class="card-body text-center">
                                <p class="card-title mt-3 product-title-card">{{ product.title }}</p>
                            </div>
                        </div>
                    </slide>
                </carousel>
            </div>
        </div>
    </div>
</section>
